import React from 'react';
import './Pagination.css';

const Pagination = ({ currentPage, totalPages, totalItems, onPageChange, pageSize, onPageSizeChange }) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const handlePageClick = (page) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage <= 3) {
                for (let i = 1; i <= 4; i++) pages.push(i);
                pages.push('...');
                pages.push(totalPages);
            } else if (currentPage >= totalPages - 2) {
                pages.push(1);
                pages.push('...');
                for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
            } else {
                pages.push(1);
                pages.push('...');
                pages.push(currentPage - 1);
                pages.push(currentPage);
                pages.push(currentPage + 1);
                pages.push('...');
                pages.push(totalPages);
            }
        }

        return pages;
    };

    const pageSizes = [10, 25, 50, 100];

    return (
        <div className="pagination-container">
            <div className="pagination-info">
                Showing <span className="pagination-highlight">{Math.min(((currentPage - 1) * pageSize) + 1, totalItems)}</span> to{' '}
                <span className="pagination-highlight">{Math.min(currentPage * pageSize, totalItems)}</span> of{' '}
                <span className="pagination-highlight">{totalItems}</span> tasks
            </div>

            <div className="pagination-actions-wrapper">
                <div className="pagination-controls">
                    <button
                        className="pagination-btn pagination-btn-prev"
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                        title="Previous page"
                    >
                        ‹
                    </button>

                    {getPageNumbers().map((page, index) => (
                        page === '...' ? (
                            <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                                ...
                            </span>
                        ) : (
                            <button
                                key={page}
                                className={`pagination-btn ${currentPage === page ? 'pagination-btn-active' : ''}`}
                                onClick={() => handlePageClick(page)}
                            >
                                {page}
                            </button>
                        )
                    ))}

                    <button
                        className="pagination-btn pagination-btn-next"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                        title="Next page"
                    >
                        ›
                    </button>
                </div>

                <div className="pagination-size">
                    <label htmlFor="page-size-select">Show:</label>
                    <select
                        id="page-size-select"
                        className="pagination-size-select"
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                    >
                        {pageSizes.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                    <span>per page</span>
                </div>
            </div>
        </div>
    );
};

export default Pagination;
